import React from "react";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";
import i18n from "../../i18n/config";

// ui components
import Card from "../Common/Card/Card";
import Action from "../Common/Action";

const EnrollCard: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <Card
    title={i18n.t("PAGES.AUTH.LOGIN.ENROLL_CARD.TITLE")}
    titleWeight="strong"
    footer={<Action
      displayType={ACTION_DISPLAY_TYPES.SECONDARY}
      title={i18n.t("PAGES.AUTH.LOGIN.ENROLL_CARD.BUTTON_TITLE")}
      className="btn-md"
      dataCy="enroll-button"
      onClick={onClick}
    />
    }
    footerClassName="bwp-card__footer--compact"
    footerProps={{ stretch: true, divided: false }}
  />
);

export default EnrollCard;
